import React from 'react';

import { faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Card,
    ListGroup,
    Button, ButtonGroup,
} from 'react-bootstrap';

import {
    useUserBookmarks,
    deleteBookmark,
} from './hook';
import {
    countryCodeToNameMap,
    languageCodeToNameMap,
    suggestQuery,
} from './memory';
import { capitalizeFirstLetter } from './utils';
import { formatTimeToDate } from './utils'

export default function ({ updateQuery }) {
    return (
        <>
        <Suggestion updateQuery={updateQuery} />
        <Bookmark updateQuery={updateQuery} />
        <PowerBy />
        </>
    );
}

const PowerBy = () => (
    <Card className="my-1">
        <Card.Body>
            <Card.Text>
                Powered by
                {'  '}
                <a
                    target="_blank"
                    href="https://newsapi.org/"
                    rel="noopener noreferrer"
                >
                    NewsAPI.org
                </a>
                {'  '}
            </Card.Text>
        </Card.Body>
    </Card>
);

const QueryAsText = ({ query }) => {
    const queryList = [];
    if (query.type === 'top') {
        queryList.push("Top");
        if (query.category) {
            queryList.push(capitalizeFirstLetter(query.category));
        }
        if (query.country) {
            queryList.push(countryCodeToNameMap[query.country]);
        }
        if (query.source && query.source.length > 0) {
            query.source.forEach(s => queryList.push(s));
        }
        if (query.search) {
            queryList.push(query.search);
        }
    } else if (query.type === 'everything') {
        queryList.push("Everything");
        if (query.language) {
            queryList.push(languageCodeToNameMap[query.language]);
        }
        if (query.sortBy) {
            queryList.push(query.sortBy);
        }
        if (query.source && query.source.length > 0) {
            query.source.forEach(s => queryList.push(s));
        }
        if (query.from) {
            queryList.push(formatTimeToDate(query.from));
        }
        if (query.to) {
            queryList.push(formatTimeToDate(query.to));
        }
        if (query.search) {
            queryList.push(query.search);
        }
        if (query.searchInTitle) {
            queryList.push(query.searchInTitle);
        }
    }
    return (
        <>
        {queryList.map(q => (
            <mark className="mr-2" key={q}>{q}</mark>
        ))}
        </>
    );
};

const Suggestion = ({ updateQuery }) => (
    <Card className="my-1">
        <Card.Header>Suggestion</Card.Header>
        <ListGroup variant="flush">
            {suggestQuery.map((query, index) => (
                <ListGroup.Item key={index}>
                    <QueryAsText query={query} />
                    <Button
                        variant="outline-info"
                        className="float-right"
                        size="sm"
                        onClick={() => updateQuery(query)}
                    >
                        <FontAwesomeIcon icon={faSearch} pull="right" />
                    </Button>
                </ListGroup.Item>
            ))}
        </ListGroup>
    </Card>
);

const Bookmark = ({ updateQuery }) => {
    const bookmarks = useUserBookmarks();
    if (bookmarks.length === 0) return (
        <Card className="my-1">
            <Card.Header>Bookmark</Card.Header>
            <Card.Body>
                <Card.Text>
                    Nothing is here...
                </Card.Text>
            </Card.Body>
        </Card>
    );
    return (
        <Card className="my-1">
            <Card.Header>Bookmark</Card.Header>
            <ListGroup variant="flush">
                {bookmarks.map((query, index) => (
                    <ListGroup.Item key={index}>
                        <QueryAsText query={query} />
                        <ButtonGroup className="float-right" size='sm'>
                            <Button variant="outline-warning">
                                <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteBookmark(query.id)} />
                            </Button>
                            <Button variant="outline-warning" onClick={() => updateQuery(query)}>
                                <FontAwesomeIcon icon={faSearch} />
                            </Button>
                        </ButtonGroup>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </Card>
    );
}
